import PersonalImage from "../../Assets/PersonalImage.jpg";
import { PROFILE } from "../../Data/siteData";

const SideProfileInfo = () => {
    return (
        <div className="sm:flex lg:block items-center">
            {/* ── Photo ── */}
            <div
                className="mx-auto sm:mx-0 lg:mx-auto flex-shrink-0 relative"
                style={{ width: "fit-content" }}
            >
                {/* Gold gradient ring */}
                <div
                    style={{
                        width: "130px",
                        height: "130px",
                        borderRadius: "50%",
                        padding: "2px",
                        background:
                            "linear-gradient(135deg, #C8972A 0%, rgba(200,151,42,0.15) 50%, #C8972A 100%)",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                            overflow: "hidden",
                            border: "3px solid rgba(4,16,32,0.95)",
                        }}
                    >
                        <img
                            src={PersonalImage}
                            alt={PROFILE.name}
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>

                {/* Online indicator */}
                <div
                    style={{
                        position: "absolute",
                        bottom: "7px",
                        right: "7px",
                        width: "13px",
                        height: "13px",
                        background: "#22c55e",
                        borderRadius: "50%",
                        border: "2.5px solid rgba(4,16,32,0.95)",
                        boxShadow: "0 0 6px rgba(34,197,94,0.5)",
                    }}
                />
            </div>

            {/* ── Info ── */}
            <div className="text-center sm:text-left lg:text-center ml-0 sm:ml-8 lg:ml-0 mt-5 sm:mt-0 lg:mt-5 min-w-0">
                {/* Name */}
                <h3
                    className="font-bold text-white mb-1"
                    style={{ fontSize: "18px", letterSpacing: "-0.01em" }}
                >
                    {PROFILE.name}
                </h3>

                {/* Positioning line */}
                <p
                    className="mb-3"
                    style={{
                        fontSize: "10px",
                        color: "rgba(200,151,42,0.75)",
                        letterSpacing: "0.12em",
                        textTransform: "uppercase",
                        fontWeight: 500,
                    }}
                >
                    Based in Australia · Remote &amp; Freelance
                </p>

                {/* Role badge — static, no truncation */}
                <span
                    style={{
                        display: "inline-block",
                        padding: "5px 12px",
                        background: "rgba(200,151,42,0.08)",
                        border: "1px solid rgba(200,151,42,0.22)",
                        borderRadius: "6px",
                        fontSize: "11px",
                        color: "#C8972A",
                        fontWeight: 500,
                        letterSpacing: "0.01em",
                        whiteSpace: "nowrap",
                        maxWidth: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    title={PROFILE.tagline}
                >
                    {PROFILE.tagline}
                </span>
            </div>
        </div>
    );
};

export default SideProfileInfo;
